package ru.playa.sce.dto

enum class TextType(val displayName: String) {
    TEXT_BANNER("Текстовый баннер"),
    GRAPHICAL_BANNER("Графический баннер"),
    PAGE_TEXT("Текст на странице"),
    NEWS_ITEM("Новостной блок"),
    SERVICES("Дополнительные услуги")
}